import { 
  useCallback, 
  useContext, 
  useEffect, 
  useState 
} from 'react'
import update from 'immutability-helper'

import { ContextApi } from '../../context/contextApi.js';
import { DragLine } from './dragLine.jsx'

import styles from './style.module.scss';
import { DrawerContext } from '../../context/drawerContext.js';

const style = {
  width: 400,
  padding: 20,
  backgroundColor: '#2B292A',
}

export const Container = () => {
    const { 
      ordenarEstados, 
      allEstadosOrdering 
    } = useContext(ContextApi)

  {
    const [cards, setCards] = useState(allEstadosOrdering)

    useEffect(() => {
        let ids;
        ids = cards.map(id => id.id)
          const idPosition = {
            ids
          }
          ordenarEstados(idPosition)            
    }, [cards])
    const moveCard = useCallback((dragIndex, hoverIndex) => {
      setCards((prevCards) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex]],
          ],
        }),
      )
    }, [])
    const renderCard = useCallback((card, index) => {
      return (
        <>
            <DragLine
              key={card.id}
              index={index}
              id={card.id}
              ufSigla={card.estado_sigla}
              text={card.nome}
              moveCard={moveCard}
              />
        </>
      )
    }, [])
    return (
      <>
        <span className={styles.titleDragContainer}>Arraste e solte os estados na posição desejada</span>
        <div style={style}>{cards?.map((card, i) => renderCard(card, i))}</div>
      </>
    )
  }
}
